module.exports = __webpack_public_path__ + "img/background.2fd48e50.jpg";